import script from "./UpdateHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateHtml.vue?vue&type=script&setup=true&lang=js"

import "./UpdateHtml.vue?vue&type=style&index=0&id=4719ce6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4719ce6c"]])

export default __exports__